module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/vi/5-8446ec78e064ada19afff7b38e27ee7c.jpg";